import { faCircleCheck, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components';
import PublishRefModel from 'models/PublishRefModel';
import { PublishGateResource } from 'services/health';
import PublishProgressBar from './PublishProgressBar';

type IProps = {
  model: PublishRefModel;
  gateResource?: PublishGateResource;
};

const GATE_COLOR: Record<string, string> = {
  green: '#15803d',
  warning: '#f59e0b',
  red: '#b91c1c',
};

const PublishRef: React.FC<IProps> = (props) => {
  const { name, publishing, completed, failed, items, done, batch } = props.model;
  const gateStatus = props.gateResource?.status;

  const total = items.length;
  const percent = total > 0 ? (done.length * 100) / total : 0;
  const pending = !publishing && !completed && !failed;

  return (
    <Resource $dim={pending}>
      <GateDot $color={gateStatus ? GATE_COLOR[gateStatus] ?? '#9ca3af' : '#9ca3af'} title={gateStatus ? `gate: ${gateStatus}` : ''} />
      <Name>{name}</Name>
      {publishing && (
        <>
          <PublishProgressBar percent={percent} indeterminate={batch === 0 || total === 0} />
          <Count>{batch === 0 || total === 0 ? 'publishing…' : `${done.length}/${total}`}</Count>
        </>
      )}
      {completed && (
        <>
          <PublishProgressBar percent={100} tone="success" />
          <Count $tone="#15803d">
            <StateIcon icon={faCircleCheck} /> {total > 0 ? total : 'all'}
          </Count>
        </>
      )}
      {failed && (
        <>
          <PublishProgressBar percent={100} tone="error" />
          <Count $tone="#b91c1c">
            <StateIcon icon={faTriangleExclamation} /> failed
          </Count>
        </>
      )}
      {pending && <Count>queued</Count>}
    </Resource>
  );
};

export default PublishRef;

const Resource = styled.div<{ $dim: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 0;
  max-width: 520px;
  opacity: ${({ $dim }) => ($dim ? 0.55 : 1)};
`;

const GateDot = styled.span<{ $color: string }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
  flex-shrink: 0;
`;

const Name = styled.span`
  width: 170px;
  flex-shrink: 0;
  font-size: 13px;
  color: #1f2937;
`;

const Count = styled.span<{ $tone?: string }>`
  width: 90px;
  flex-shrink: 0;
  text-align: right;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  color: ${({ $tone }) => $tone ?? '#6b7280'};
`;

const StateIcon = styled(FontAwesomeIcon)`
  font-size: 12px;
  margin-right: 2px;
`;
